import React, { useState } from "react";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { Modal } from "react-bootstrap";
import axios from "../../API/axios";
import toast from "react-hot-toast";

const HiringStatus = ({ jobAppInfoData }) => {
  const sessionId = localStorage.getItem("sessionId");

  //   States
  const [statusModal, setStatusModal] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [currentJobId, setCurrentJobId] = useState(null);
  const [currentHiringStatus, setCurrentHiringStatus] = useState(null);
  const [remark, setRemark] = useState("");
  const [hiringStatus, setHiringStatus] = useState(
    jobAppInfoData.hiringStatusName
  );

  //   Handle Submit Hiring Status
  const handleSubmit = () => {
    console.log("========>");
    console.log("currentJobId", currentJobId, currentHiringStatus);
    if (currentJobId && currentHiringStatus) {
      HiringStatus(currentJobId, currentHiringStatus);
    }
    setStatusModal(false);
  };

  //   Handle Status
  const handleStatusModal = (jobId = null, hiringStatus = null) => {
    setCurrentJobId(jobId);
    setCurrentHiringStatus(hiringStatus);
    setStatusModal(!statusModal);
  };

  //   Handle Schedul
  const handleScheduleModal = (jobId = null) => {
    setCurrentJobId(jobId);
    setScheduleModal(!scheduleModal);
  };

  //   Setting Hiring status
  const HiringStatus = (jobId, hiringStatus) => {
    const data = {
      sessionId: sessionId,
      jbApplctnId: jobId,
      hiringStatus: hiringStatus,
      remark: remark,
    };
    console.log("data====>", data);
    axios
      .post(`JobApplication/UpdateHiringStatus`, data)
      .then((response) => {
        const res = response.data.responseData;
        toast.success(res);
        setRemark("");
      })
      .catch((e) => {
        console.log(e);
        if (e.response && e.response.status === 404) {
          toast.warning(e.response.data.message);
        } else {
          toast.error(e.response.data.message);
        }
      });
  };

  return (
    <>
      {jobAppInfoData?.hiringStatus === 4 ? (
        <div className="post-form-group interview-schedul-list mb-1">
          <select
            className="ct-tab-dropdown"
            value={hiringStatus}
            onChange={(e) => {
              const selectedValue = e.target.value;
              console.log(selectedValue);
              if (selectedValue === "Scheduled") {
                setHiringStatus(selectedValue);
                handleScheduleModal(jobAppInfoData?.jbApplctnId);
              } else {
                setHiringStatus(selectedValue);
                handleStatusModal(jobAppInfoData?.jbApplctnId, selectedValue);
              }
            }}
          // style={{
          //   width: "150px",
          //   padding: "8px",
          //   borderRadius: "4px",
          //   border: "1px solid #ccc",
          //   background: "#fff",
          //   appearance: "none",
          // }}
          >
            {[
              { label: "DECLINED", value: "Declined", disabled: true },
              { label: "SHORTLISTED", value: "Shortlisted", disabled: true },
              { label: "SCHEDULED", value: "Scheduled" },
              { label: "HIRED", value: "Hired" },
              { label: "REJECTED", value: "Reject" },
              { label: "BLOCK", value: "Block" },
            ].map((option) => (
              <option
                key={option.value}
                value={option.value}
                disabled={option.disabled}
                className={option.disabled ? "disabled-style" : ""}
              >
                {option.label}
              </option>
            ))}
          </select>
        </div>
      ) : (
        <div className="badgeContainer">
          {jobAppInfoData.hiringStatus === 6 ? (
            <div className="badge badge-notification hired me-3 mb-1">
              {jobAppInfoData?.hiringStatusName}
            </div>
          ) : jobAppInfoData.hiringStatus === 7 ? (
            <div className="badge badge-notification rejected me-3 mb-1">
              {jobAppInfoData?.hiringStatusName}
            </div>
          ) : (
            <div className="badge badge-notification me-3 mb-1">
              {jobAppInfoData?.hiringStatusName}
            </div>
          )}
        </div>
      )}

      {/* Modal for Hiring status */}

      <Modal show={statusModal} onHide={handleStatusModal} centered>
        <Modal.Header>
          <Modal.Title> Update Hiring Status</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleStatusModal} />
        </Modal.Header>
        <Modal.Body className="settings">
          <div className="d-flex modalBorder pb-4 d-flex justify-content-center px-4">
            <div className="col-md-12 mt-2 ps-0 mb-2 userInput d-flex flex-column align-items-center">
              <div className="col-md-12 mt-2">
                <label htmlFor="remark">Remark</label>
                <input
                  type="text"
                  style={{ width: "100%" }}
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger apply-job me-2"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default HiringStatus;
